import { FlexLayout, FlexView } from '../../components/layout/Flex';
import { Project, Description } from '../../components/Text';
import { CoovMockUp } from '../../assets/visual/png/icons';

const Coov = () => {
	return (
		<FlexLayout>
			<FlexView align="center">
				<img src={CoovMockUp} alt="mockupCoov" width="40%" height="auto" />
			</FlexView>
			<FlexView
				style={{
					justifyContent: 'center',
				}}
				direction="column"
			>
				<Project>{`COVID-19
					Digital Certificate
					`}</Project>
				<Description strong>{`
					MAU 10M+
					Cumulative Downloads 30M+`}</Description>
				<Description>{`
					API Version 2 Update
					Front-end Engineering
					Improved UI based on Laws of UX`}</Description>
			</FlexView>
		</FlexLayout>
	);
};

export default Coov;
